/**
 * 应用全局配置
 */

/**
 * Portfolio 数据刷新间隔（毫秒）
 * 默认：120000ms (2分钟)
 */
export const PORTFOLIO_REFRESH_INTERVAL = 120000; // 2分钟

/**
 * Portfolio 总价值计算配置
 * 是否将链上代币余额计入总价值
 * 默认：false (只计算 Position 价值)
 */
export const INCLUDE_ON_CHAIN_BALANCE = true;

/**
 * 支持的代币配置（用于链上余额查询）
 */
export const SUPPORTED_TOKENS = {
  USDC_E: {
    address: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    decimals: 6,
    symbol: 'USDC.e',
    chain: 'polygon',
  },
  P_USD: {
    address: '0xC011a7E12a19f7B1f670d46F03B03f3342E82DFB',
    decimals: 6,
    symbol: 'pUSD',
    chain: 'polygon',
  },
  // 可以添加更多代币...
} as const;

/**
 * Polygon RPC 端点
 * 使用 PublicNode 免费端点，稳定且无需 API key
 */
export const POLYGON_RPC_URL = 'https://polygon-bor-rpc.publicnode.com';

/**
 * 其他配置可以在这里添加
 */
